// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"426":"865fbf15","671":"865fbf15","996":"1d4f6229"}[chunkId] + ".css";
};